import { Term } from './AutocompleteTermStore';
export class AutocompleteTrendingStore extends Array {
    static get [Symbol.species]() {
        return Array;
    }
    constructor(services, trendingData, resetTerms, rootState) {
        const terms = [];
        trendingData?.trending?.queries?.map((term) => {
            terms.push(new Term(services, {
                active: false,
                value: term.searchQuery,
            }, terms, resetTerms, rootState));
        });
        super(...terms);
    }
}
